// @flow
import { withStyle } from 'styletron-react'
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from '../../../utils'
import { Container as CardContainer } from '../CreditCardItem/elements'

export { TryAgainButtonContainer } from '../elements'

export const Container = styled(
  'div',
  getScreenStyles(
    'xs',
    {},
    {
      marginTop: '10px',
      marginBottom: '10px',
    }
  )
)

export const LoadingContainer = withStyle(CardContainer, {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const ErrorContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
})

// Adds bottom margin to the card item
export const CreditCardWrapper = styled(
  'div',
  getScreenStyles(
    'xs',
    {},
    {
      ':not(:last-child)': {
        marginBottom: '10px',
      },
    }
  )
)
